export interface StartScreenProps {
  onStart: () => void;
  busy: boolean;
  failed: boolean;
  lastError: string | null;
  onRetry: () => void;
}

/**
 * Nothing audio-related happens before the user acts here: no AudioContext, no
 * nodes, and no microphone permission request (Phase 2 adds Enable Input as a
 * separate action).
 */
export function StartScreen({ onStart, busy, failed, lastError, onRetry }: StartScreenProps) {
  return (
    <main className="start">
      <h1 className="start__title">Web Improvisation</h1>
      <p className="start__lede">
        ブラウザだけで動く即興ジェネラティブミュージック。
        <br />
        現在は <strong>Phase 1A（Rhythm Foundation）</strong> です。リズムのみを生成します。
      </p>

      <section className="start__section" aria-labelledby="privacy-title">
        <h2 id="privacy-title">プライバシー</h2>
        <ul>
          <li>音声入力はまだ使用しません（Phase 2で追加します）</li>
          <li>入力音はブラウザ内でのみ処理し、サーバーへ送信しません</li>
          <li>録音も保存もしません</li>
          <li>マイク権限は、必要になった時点でユーザー操作を起点に要求します</li>
        </ul>
      </section>

      <section className="start__section" aria-labelledby="audio-title">
        <h2 id="audio-title">再生環境</h2>
        <ul>
          <li>ヘッドホン、またはオーディオインターフェイスのDirect Monitorを推奨します</li>
          <li>初期音量は控えめです。Master limiterが常に有効です</li>
          <li>Panicはいつでも使用できます</li>
        </ul>
      </section>

      {failed && (
        <div className="start__error" role="alert">
          <p>オーディオの初期化に失敗しました。</p>
          {lastError !== null && <p className="start__error-detail">{lastError}</p>}
          <button type="button" className="button" onClick={onRetry} disabled={busy}>
            Retry
          </button>
        </div>
      )}

      <button
        type="button"
        className="button button--primary button--large"
        onClick={onStart}
        disabled={busy}
      >
        {busy ? "Starting…" : "Start Audio"}
      </button>
      <p className="start__note">
        Start
        Audioを押すとAudioContextを開始します。ブラウザの仕様上、音の再生はユーザー操作を起点にする必要があります。
      </p>
    </main>
  );
}
